module.exports = __webpack_public_path__ + "img/icon-warning-stormsurge-red.4a14ae40.svg";